import { COLOR_VARIANTS } from "./storybook.js";

//#region src/framework/theme/util/get-style-for-color.ts
const getStyleForColor = (color) => {
	if (color === "inherit") return {
		bg: "inherit",
		c: "currentColor"
	};
	if (!COLOR_VARIANTS.includes(color)) throw new Error("Only colors in the \"semantic\" palette may be passed to this function");
	return {
		bg: `var(--mantine-color-${color}-background)`,
		c: `var(--mantine-color-${color}-foreground)`
	};
};

//#endregion
export { getStyleForColor };